import React from "react";
import { Grid, Typography, Stack, Box, Container } from "@mui/material";
import "./index.css";
import CustomButton from "../generic-components/Button/Button";
import { useNavigate } from "react-router-dom";
import PermContactCalendarIcon from "@mui/icons-material/PermContactCalendar";
import Divider from "@mui/material/Divider";

const title = "Aspire Journey Through Time";
const description =
"Since our inception, Aspire has specialised in delivering tailored tax and bookkeeping services designed to meet the diverse financial needs of Australians. With a team of certified experts and a client-first approach, we simplify ATO compliance, maximise savings, and empower clients to grow with confidence.";
const visionMissionText = [
  {
    header: "Our Mission",
    description: "Our mission is to empower individuals and small businesses to achieve financial clarity, compliance, and confidence. We are dedicated to providing accurate, timely, and fully ATO-compliant tax, accounting, and bookkeeping services, ensuring our clients meet their obligations while maximising their financial opportunities. ",
  },
  {
    header: "Our Vision",
    description: "Aspire Tax and Bookkeeping empowering individuals and businesses with clarity, compliance, and long-term financial success. We strive to redefine professional financial services through accuracy, innovation, and a client-first approach, ensuring every client feels supported, informed, and confident in their financial future, we prioritise personalised solutions, tailoring our Tax, Accounting, and Bookkeeping services to meet the unique needs of individuals, sole traders, and businesses across Australia.",
  },
  {
    header: "Our Values",
    description: "At Aspire, we’re guided by integrity, accuracy, innovation, and client satisfaction. We believe in transparent communication, ethical practices, and always staying ahead in compliance and technology — ensuring every client receives dependable and forward-looking financial care.",
  },
];

function VisionMission() {
  const navigate = useNavigate();
  const handleNavigation = (route) => {
    if (route) {
      navigate(route);
    }
  };

  return (
    <Box sx={{width:'100%', display:'flex ', justifyContent:'center'}}>
      <Container maxWidth="xl" sx={{ m:0 }}>
        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          className="grid-container"
        >
          <Stack spacing={2} sx={{ width: "100%" }}>
            <Typography className="vision-title-text" color="#0A0A7B" align="center">
              {title}
            </Typography>

            <Typography className="vision-description-text">{description}</Typography>
          </Stack>

          <Stack
            direction={{ xs: "column", md: "row" }}
            spacing={2}
            sx={{ width: "100%" }}
          >
            {visionMissionText.map((item, index) => (
              <React.Fragment key={index}>
                {index > 0 && (
                  <Divider
                    orientation={{ xs: "horizontal", md: "vertical" }}
                    flexItem
                    sx={{
                      width: { md: "2px", xs: "auto" },
                      height: { xs: "2px", md: "auto" },
                      backgroundColor: "#0A0A7B",
                      my: { xs: 2, md: 0 },
                      mx: { xs: 0, md: 2 },
                    }}
                  />
                )}
                <Box className="vision-mission-box" sx={{ flex: 1 }}>
                  <Typography
                    className="vision-mission-header"
                    color="#0A0A7B"
                    align="center"
                  >
                    {item.header}
                  </Typography>

                  <Typography
                    className="vision-mission-description"
                    align="center"
                  >
                    {item.description}
                  </Typography>
                </Box>
              </React.Fragment>
            ))}
          </Stack>

          <Box
            sx={{ width: "100%", display: "flex", justifyContent: "center" }}
          >
            <CustomButton
              className="contact-us-button"
              startIcon={<PermContactCalendarIcon />}
              text="Contact Us"
              onClick={() => handleNavigation("/contact-us")}
            />
          </Box>
        </Grid>
      </Container>
    </Box>
  );
}

export default VisionMission;
